module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-3eb376e00fe8a6a2eaf9938d5b64d4f3.ttf";